import type { Language } from "../../features/wedding/domain/language";

type Route = { kind: "admin" } | { kind: "wedding"; lang: Language };

export function getRoute(pathname: string): Route {
  const normalizedPath = pathname.replace(/\/+$/, "") || "/";

  if (normalizedPath === "/admin") {
    return { kind: "admin" };
  }

  if (normalizedPath === "/de") {
    return { kind: "wedding", lang: "de" };
  }

  return { kind: "wedding", lang: "it" };
}
